import {GetAllPermissionsRequest as AllPermissionsRequest, GetAllPermissionsResponse as AllPermissionsResponse,
    UpdatePermissionsRequest, UpdatePermissionsResponse } from "../../models/manage/permissions.models";
import {RequestClientService} from "@rightship-tech/common-ui/services/basic/request-client.service";
import { autoinject } from "aurelia-framework";

@autoinject
export class ManagePermissionsClientService {

    constructor(private requestClient: RequestClientService) {
    }

    getAllPermissions(request: AllPermissionsRequest): Promise<AllPermissionsResponse> {
        return this.requestClient.get<AllPermissionsResponse>("permissions", request);
    }

    save(request: UpdatePermissionsRequest): Promise<UpdatePermissionsResponse> {
        return this.requestClient.post<UpdatePermissionsResponse>("permissions", {}, request);
    }
}
